import {
  LLMApiType,
  ASRProviderModel,
  ASRProviderSettingsType,
  OpenAICompatibleASRResponseFormat,
} from '../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'asr-provider-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FORM_ITEM_CLASS_NAME = `${CONTENT_CLASS_NAME}__form-item`;

export const EMPTY_AUDIO_LLM_ASR_PROVIDER: ASRProviderModel = {
  asr_provider_id: '',
  name: '',
  settings: {
    type: ASRProviderSettingsType.Llm,
    llm_settings: {},
    api_type: LLMApiType.ChatCompletions,
    default_prompt: '',
    allow_prompt_override: false,
  },
};

export const EMPTY_OPENAI_COMPATIBLE_ASR_PROVIDER: ASRProviderModel = {
  asr_provider_id: '',
  name: '',
  settings: {
    type: ASRProviderSettingsType.OpenAiCompatible,
    base_url: '',
    api_key: '',
    model: '',
    response_format: OpenAICompatibleASRResponseFormat.Json,
  },
};

export const DEFAULT_ASR_PROVIDER = EMPTY_AUDIO_LLM_ASR_PROVIDER;
